import { useCallback, useEffect } from "react";
import PublicHeader from "./components/PublicHeader";
import PublicHero from "./components/PublicHero";
import PublicMapSection from "./components/PublicMapSection";
import PublicIndicatorsPanel from "./components/PublicIndicatorsPanel";
import PublicProjectsSection from "./components/PublicProjectsSection";
import PublicGreenAreasSection from "./components/PublicGreenAreasSection";
import PublicReportsSection from "./components/PublicReportsSection";
import PublicCtaSearch from "./components/PublicCtaSearch";
import PublicParticipationSection from "./components/PublicParticipationSection";
import PublicRankingPanel from "./components/PublicRankingPanel";
import PublicAboutSection from "./components/PublicAboutSection";
import PublicFooter from "./components/PublicFooter";

export default function PublicPortalPage() {
  const handleNavigate = useCallback((href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    document.title = "Portal Público FloraIQ — Transparência Ambiental e Arborização Urbana";
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <PublicHeader onNavigate={handleNavigate} />
      <main>
        <PublicHero />
        <PublicMapSection />
        <PublicIndicatorsPanel />
        <PublicProjectsSection />
        <PublicGreenAreasSection />
        <PublicReportsSection />
        <PublicCtaSearch />
        <PublicParticipationSection />
        <PublicRankingPanel />
        <PublicAboutSection />
      </main>
      <PublicFooter onNavigate={handleNavigate} />
    </div>
  );
}